<section *ngIf="invoice != undefined" class="invoice mat-elevation-z3">

    <div class="grid">
        <div class="customer">
            <div>{{invoice?.customer?.business}}</div>
            <div>{{invoice?.customer?.address}}</div>
            <div><span [apPhone]="invoice?.customer?.phone">{{invoice?.customer?.phone | phone}}</span></div>
            <div>{{invoice?.customer?.email}}</div>
        </div>

        <div class="invoice-details">
            <p>
                <mat-label>Invoice number</mat-label>
                {{invoice.number}}
            </p>
            <p>
                <mat-form-field class="mat-form-field-no-padding" appearance="outline">
                    <mat-label>Invoice Date</mat-label>
                    <input matInput [matDatepicker]="picker1" [(ngModel)]="invoice.dateCreated">
                    <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                </mat-form-field>
            </p>
        </div>
    </div>

    <div class="invoice-items">

        <table mat-table [dataSource]="invoiceItemsDataSource">

            <ng-container matColumnDef="service-order-number">
                <th mat-header-cell *matHeaderCellDef>Service Order Number</th>
                <td apStatus="Item code" mat-cell class="item-cell" *matCellDef="let element;let i=index">
                    <div class="input-group">
                        <input matInput [value]="element.serviceOrderNumber" [(ngModel)]="element.serviceOrderNumber">
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="swap-over-number">
                <th mat-header-cell *matHeaderCellDef>Swap Over Number</th>
                <td apStatus="Item code" mat-cell class="item-cell" *matCellDef="let element;let i=index">
                    <div class="input-group">
                        <input matInput [value]="element.swapOverNumber" [(ngModel)]="element.swapOverNumber">
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef>Date</th>
                <td apStatus="Item code" mat-cell class="item-cell" *matCellDef="let element;let i=index">
                    <div class="input-group">
                        <input matInput [value]="element.serviceDate" [(ngModel)]="element.serviceDate">
                    </div>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>


            <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef>Fee</th>
                <td mat-cell class="price-cell" *matCellDef="let element; let i=index">
                    <ap-money (amountChange)="amountChanged($event, i)" class="amountInput" [(amount)]="element.price"></ap-money>
                </td>
                <td class="invoiceTotal" mat-footer-cell *matFooterCellDef>{{invoice.total | human}}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell class="price-cell" *matCellDef="let element;let i = index">
                    <button (click)="deleteLineItem(i)" mat-icon-button>
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>

        </table>


        <div class="add-line-item">
            <button mat-button (click)="addLineItem()">Add line item</button>
        </div>

        <div class="invoice-actions">
            <button (click)="save()" mat-raised-button color="primary">Save</button>
        </div>

    </div>

</section>